import { config } from "../config";

export const BASE_URL = config.apiBaseUrl;

export const VALIDATION_MESSAGES = {
    EMAIL_INVALID: "Please enter a valid email address.",
    PASSWORD_REQUIRED: "Password is required.",
    PASSWORD_WEAK: "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    PHONE_INVALID: "Please enter a valid 10-digit phone number.",
    PHONE_REQUIRED: "Phone number is required.",
    LOGIN_INVALID_CREDENTIALS: "The credentials you entered are incorrect. Please try again.",
};
